/**
 * Gestión de la página Landing
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2003-2025 Mendikat
 * @license Mendikat
 * @version {see config/app.php}
 */

// Gestión de las modales comerciales
import Business from '../common/business';

// Lefatlet
import { LMap, LTileLayer, LControl, LMarker, LIcon, LPopup } from 'vue2-leaflet';
import { latLng } from 'leaflet';
import LControlFullscreen from 'vue2-leaflet-fullscreen';

// Estilos propios de Lefalet
import 'leaflet/dist/leaflet.css';
L.Icon.Default.prototype.options.imagePath = '/images/vendor/leaflet/dist/';

// VueCoolLightbox
// @link https://vue-cool-lightbox.lucaspulliese.com
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

// moment.js
// @link https://momentjs.com/
import moment from 'moment';

// Axios
const { default: Axios } = require('axios');

new Vue({
    el: '#app',
    components: {
        LMap,
        LTileLayer,
        LControl,
        LMarker,
        LIcon,
        LPopup,
        LControlFullscreen,
        coollightbox : CoolLightBox,
    },
    mixins: [Business],
    data:
        {
            // El idioma actual de la página
            lang : 'es',

            // Las imágenes de la galería
            images : [],

            // La imagen actualmente seleccionada
            image  : null,

            // El slide mostrado
            slide  : 0,

            // Si el slade está en marcha o no
            sliding: null,

            // Si el mapa de cumbres debe ser mostrado o no
            mapMustBeShowed: false,

            // El mapa
            map :
                {
                    object      : null,                                 // EL propio objeto
                    zoom        : 10,                                   // El nivel de zoom
                    center      : latLng(0, 0),    // El centro del mapa
                    provider    : null,                                 // El proveedor de cartografía
                    summits     : [],                                   // Una lista de cumbres representadas
                },

            // Los proveedores de cartografía digital
            providers  : [],

            // La información de la autoría (información sobre el autor seleccionado)
            authorInfo : null,

            // El usuario actual (si es un usuario registrado)
            user      : {},

        },
    mounted: function () {

        // Fija el idioma actual de la página
        this.lang = lang.value;

        // Carga las imágenes
        this.loadImages();

        // Carga los proveedores de cartografía digital
        this.loadMapProviders();

        // Inicializa el mapa (si este debe ser mostrado)
        if (this.mapMustBeShowed) {
            this.initMap();
        }
    },
    methods: {
        /**
         * Carga las imágenes
         *
         */
        loadImages: function () {
            this.images = JSON.parse(images.value);

            this.images.forEach(image => this.completeImage(image));
        },
        /**
         * Completa la información de una imagen
         *
         * @param {Image} image
         *
         */
        completeImage: function (image) {
            // Añade la ruta de la imagen
            image.src = image.path;

            // La descripción (pié de la imagen) incluye el autor, el título y la fecha en la que ha sido obtenida o,
            // en su defecto, la fecha de creación
            image.description = `<a href="${image.url}"><i class="fas fa-camera fa-2x"></i></a>
                                <span class="text-align-fa-2x ml-2">
                                    <a href="${image.itemUrl}">${image.item}</a> → ${image.author ? image.author : '?' } → ${moment(image.taken_at ? image.taken_at : image.created_at).format('DD-MM-YYYY')}
                                </span>`;
        },
        /**
         * Abre el visor para mostrar una imagen de la galería
         *
         * @param {Number} image    El índice de la imagen
         *
         */
        showImage(image) {

            // Cambia la imagen
            this.image = image;

            // Se produce un alineamiento no deseado mientras carga la imagen
            // que curiosamente se resuelve al redimensionar la pantalla
            // Por ello, se fuerza el evento 'resize' con una demora que parece igualmente necearia
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 250);
        },
        /**
         * Carga la lista de proveedores de cartografía digital
         *
         */
        loadMapProviders: function () {
            this.providers = JSON.parse(providers.value);
        },
        /**
         * Inicializa el mapa
         *
         */
        initMap: function () {

            // Obtiene el proveedor de cartografía a utilizar por defecto
            const defaultProvider = this.$refs.providers.dataset.default;

            this.map =
                {
                    object      : this.$refs.map.mapObject,
                    zoom        : parseInt(map.dataset.zoomStart),
                    center      : latLng(40.85, -3.96),
                    provider    : this.providers[defaultProvider],
                    summits     : [],
                };
        },
        /**
         * Obtiene los límites del mapa
         *
         * @returns {Bounds}        Los límites del mapa
         *
         */
        getMapBounds: function () {
            let bounds = this.map.object.getBounds();

            return {
                north : bounds.getNorth(),
                east  : bounds.getEast(),
                south : bounds.getSouth(),
                west  : bounds.getWest(),
            };
        },
        /**
         * Actualiza las cumbres en el mapa
         *
         */
        updateSummits: function () {

            // Actualiza el nivel de zoom del mapa
            this.map.zoom = this.map.object.getZoom();

            // No se admite un nivel de zoom por encima del máximo para el proveedor de cartografñia digital
            if (this.map.zoom > this.map.provider.options.maxZoom) {
                this.map.object.setZoom(this.map.provider.options.maxZoom);
                return;
            }

            // Obtiene los límites del mapa
            let bounds = this.getMapBounds();

            Axios.post('/com/map/get-mountains',
                {
                    bounds: bounds,
                }
            ).then(response => {
                // Filtra las montañas para mostrar únicamente las que forman parte del país
                this.map.summits = response.data;
            }).catch(error => {
                console.error(error);
            });
        },
        /**
         * Al hacer click en el mapa se activa el uso de la rueda del ratón
         * para hacer zoom sobre el mismo
         *
         *
         */
        toggleScrollWheelZoom: function () {

            if (this.map.object.scrollWheelZoom.enabled()) {
                this.map.object.scrollWheelZoom.disable();
            } else {
                this.map.object.scrollWheelZoom.enable();
            }
        },
        /**
         * Al iniciar el Slading
         *
         * @param {Slide} slide
         *
         */
        onSlideStart(slide) {
            this.sliding = true
        },
        /**
         * Al finalizar el Slading
         *
         * @param {Slide} slide
         *
         */
        onSlideEnd(slide) {
            this.sliding = false
        },
        /**
         * Muestra la información del autor
         *
         * @param {Author} author
         *
         */
        showAuthorInfo: function (author) {

            // Muestra el loader
            waiting.show();

            // Obtiene la información del autor
            Axios.post(`/com/user/author/info/${author}`)
                .then(response => {

                    // Oculta el loader
                    waiting.hide();

                    // La información del autor
                    this.authorInfo = response.data;

                    // Oculta la modal de confirmación de la eliminación
                    this.$bvModal.show('modal-author-info');
                })
                .catch(error => {
                    console.error(error);
                });
        },
        /**
         * Obtiene las iniciales del usuario autor
         *
         * @param {String} author   El autor
         *
         * @returns {String}        Las iniciales del usuario
         *
         */
        getAuthorInitials: function (author) {
            let regex= new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

            let initials = [...author.matchAll(regex)] || [];

            return (
              (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
            ).toUpperCase();
        },
    },
    computed: {
        /**
         * Cuando el mapa ha sido inicializado
         *
         * @returns {Boolean}       true si el mapa ha sido inicializado
         */
        mapInitialized: function () {
            return this.map.provider != null;
        },
    },
    filters: {
        /**
         * Formatea el nombre de una cumbre
         *
         * @param {String} name         El nombre de la cumbre
         *
         */
        name: function (name) {
            return name.split('/')[0];
        },
        /**
         * Formatea un valor de altitud
         *
         * @param {Number} value        Un valor de altitud
         *
         * @returns {String}            La altitud formateada
         *
         */
        altitude: function (value) {
            return `${parseInt(value)} m`;
        },
        /**
         * Formatea una fecha
         *
         * @param {Date} value          Una fecha
         * @returns {String}            Una fecha formateada
         */
        date: function (value) {
            return moment(value).format('DD-MM-YYYY');
        },
    },
});